/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { checkStatus, ConversationAPI as API } from '@driftt/dapper'
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import * as  RequestContentType from 'constants/RequestContentType'
import { encodeQueryData } from 'utils/Helpers'

const ConversationAPI = Marty.createStateSource({
  id: 'ConversationAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CONVERSATION_API,

  fetchConversationsById(conversationIds) {
    return this.post({
      url: 'conversations/find',
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify({ ids: conversationIds })
    })
  },

  fetchRecentOpenConversations() {
    return this.get({
      url: 'conversations/open',
      headers: getAuthorizationHeader()
    })
  },

  fetchConversation(conversationId) {
    return this.get({
      url: `/conversations/${ conversationId }`,
      headers: getAuthorizationHeader()
    })
  },

  searchConversations(query) {
    return this.get({
      url: `/conversations/search?q=${ encodeURI(query) }`,
      headers: getAuthorizationHeader()
    })
  },

  sendActiveStatus() {
    return this.post({
      url: "/agents/active",
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  },

  sendMobileNotificationTest() {
    return this.post({
      url: "/notifications/test/push",
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  },

  sendEmailNotificationTest() {
    return this.post({
      url: "/notifications/test/email",
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  },

  sendBrowserNotificationTest() {
    return this.post({
      url: "/notifications/test/web",
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  }

})

export default ConversationAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/ConversationAPI.js